<template>
  <v-form>
    <v-row wrap>
      <v-col cols="12">
        <v-select
          v-if="shops.length !== 0"
          v-model="form.shop"
          :label="$t('customerFormBasic.text.shop')"
          :error-messages="errors.shop"
          :items="shops"
          :item-text="shop => `${shop.code} ${shop.name}`"
          item-value="id"
          @blur="emit"
        />
        <span v-else>
          {{ value && value.shopName }}
        </span>
      </v-col>
      <v-col v-if="$i18n.locale === 'ja'" cols="6">
        <v-text-field
          v-model="form.familyNameKana"
          :label="$t('customerFormBasic.text.familyNameKana')"
          :error-messages="errors.familyNameKana"
          @blur="emit"
        />
      </v-col>
      <v-col v-if="$i18n.locale === 'ja'" cols="6">
        <v-text-field
          v-model="form.givenNameKana"
          :label="$t('customerFormBasic.text.givenNameKana')"
          :error-messages="errors.givenNameKana"
          @blur="emit"
        />
      </v-col>
      <v-col cols="6">
        <v-text-field
          v-model="form.familyName"
          :label="$t('customerFormBasic.text.familyName')"
          :error-messages="errors.familyName"
          @blur="emit"
        />
      </v-col>
      <v-col cols="6">
        <v-text-field
          v-model="form.givenName"
          :label="$t('customerFormBasic.text.givenName')"
          :error-messages="errors.givenName"
          @blur="emit"
        />
      </v-col>
      <v-col cols="3">
        <v-text-field
          v-model="form.phoneNumber"
          :label="$t('customerFormBasic.text.phoneNumber')"
          type="tel"
          :error-messages="errors.phoneNumber"
          @blur="emit"
        />
      </v-col>
      <v-col cols="6">
        <v-text-field
          v-model="form.email"
          :label="$t('customerFormBasic.text.email')"
          :error-messages="errors.email"
          @blur="emit"
        />
      </v-col>
      <v-col cols="3">
        <v-select
          v-model="form.age"
          :label="$t('customerFormBasic.text.age')"
          :items="ageOptions"
          :error-messages="errors.age"
          @change="emit"
        />
      </v-col>
      <v-col cols="3">
        <v-text-field
          v-model="form.birthday"
          type="date"
          :label="$t('customerFormBasic.text.birthday')"
          clearable
          :error-messages="errors.birthday"
          @change="emit"
        />
      </v-col>
      <v-col cols="3">
        <v-select
          v-model="form.gender"
          :label="$t('customerFormBasic.text.gender')"
          :items="genderOptions"
          :error-messages="errors.gender"
          @change="emit"
        />
      </v-col>
      <v-col cols="3">
        <v-select
          v-model="form.patchTest"
          :label="$t('customerFormBasic.text.patchTest')"
          :items="patchTestOptions"
          :error-messages="errors.patchTest"
          @change="emit"
        />
      </v-col>
      <v-col cols="3">
        <v-checkbox
          v-model="form.receivesInfo"
          :label="$t('customerFormBasic.text.receivesInfo')"
          :error-messages="errors.receivesInfo"
          @change="emit"
        />
      </v-col>
      <v-col cols="6">
        <v-textarea
          v-model="form.note"
          :label="$t('customerFormBasic.text.note')"
          outlined
          :error-messages="errors.note"
          @blur="emit"
        />
      </v-col>
      <v-col cols="6">
        <v-textarea
          v-model="form.operationNote"
          outlined
          :label="$t('customerFormBasic.text.operationNote')"
          :error-messages="errors.operationNote"
          @blur="emit"
        />
      </v-col>
      <!-- <v-col>
        <DateSelect
          v-model="form.starterPassFrom"
          label="スターターパス購入日"
          :error-messages="errors.starterPassFrom"
          clearable
          @change="emit"
        />
      </v-col> -->
    </v-row>
  </v-form>
</template>

<script>
// import DateSelect from '@/components/DateSelect'
export default {
  name: 'CustomerFormBasic',
  components: {
    // DateSelect,
  },
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
    errors: {
      type: Object,
      default: () => ({}),
    },
    shops: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    form: {
      shop: null,
      familyName: '',
      givenName: '',
      familyNameKana: '',
      givenNameKana: '',
      age: '',
      birthday: null,
      gender: '',
      phoneNumber: '',
      email: '',
      receivesInfo: false,
      patchText: null,
      note: null,
      operationNote: '',
      starterPassFrom: null,
    },
  }),
  computed: {
    ageOptions() {
      return [
        { text: this.$t('customerFormBasic.text.age10s'), value: '10代' },
        { text: this.$t('customerFormBasic.text.age20s'), value: '20代' },
        { text: this.$t('customerFormBasic.text.age30s'), value: '30代' },
        { text: this.$t('customerFormBasic.text.age40s'), value: '40代' },
        { text: this.$t('customerFormBasic.text.age50s'), value: '50代' },
        { text: this.$t('customerFormBasic.text.age60s'), value: '60代以上' },
      ]
    },
    genderOptions() {
      return [
        { text: this.$t('customerFormBasic.text.female'), value: '女性' },
        { text: this.$t('customerFormBasic.text.male'), value: '男性' },
      ]
    },
    patchTestOptions() {
      return [
        { text: this.$t('customerFormBasic.text.notFilled'), value: null },
        { text: this.$t('customerFormBasic.text.implement'), value: true },
        { text: this.$t('customerFormBasic.text.notImplement'), value: false },
      ]
    },
  },
  watch: {
    value: {
      immediate: true,
      handler(value) {
        let form = this.form
        Object.keys(form).forEach(k => {
          if (k in value) {
            form[k] = value[k]
          }
        })
      },
    },
  },
  methods: {
    emit() {
      const form = this.form
      if (!form.birthday) form.birthday = null
      this.form.givenNameKana = this.hiraToKana(this.form.givenNameKana)
      this.form.familyNameKana = this.hiraToKana(this.form.familyNameKana)
      let value = null
      if (this.value) value = Object.assign({}, this.value, this.form)
      else value = Object.assign({}, this.form)
      this.$emit('input', value)
    },
    hiraToKana(str) {
      return str.replace(/[\u3041-\u3096]/g, match => {
        let chr = match.charCodeAt(0) + 0x60
        return String.fromCharCode(chr)
      })
    },
  },
}
</script>
